const emptyPanelForSegment = (segment: any = {}) => ({
  id: segment?.id,
  azimuth: segment?.azimuth ?? 0,
  horizontal: {
    height: 0,
    width: 0,
    points: [],
    selected: []
  },
  vertical: {
    height: 0,
    width: 0,
    points: [],
    selected: []
  }
});

export const alignPanelsToSegments = (
  panels: any[] = [],
  segments: any[] = []
) => {
  if (!Array.isArray(panels)) return [];
  if (!Array.isArray(segments) || segments.length === 0) return panels;

  const panelsById = new Map<string, any>();
  panels.forEach((panel) => {
    if (panel?.id !== undefined && panel?.id !== null) {
      panelsById.set(String(panel.id), panel);
    }
  });

  const canAlignById =
    panelsById.size > 0 &&
    segments.some(
      (segment) => segment?.id !== undefined && segment?.id !== null
    );
  const alreadyAligned =
    panels.length === segments.length &&
    segments.every((segment, index) => {
      const panel = panels[index];
      if (
        segment?.id === undefined ||
        segment?.id === null ||
        panel?.id === undefined ||
        panel?.id === null
      ) {
        return true;
      }
      return String(segment.id) === String(panel.id);
    });

  if (!canAlignById || alreadyAligned) return panels;

  return segments.map((segment, index) => {
    const panelById =
      segment?.id !== undefined && segment?.id !== null
        ? panelsById.get(String(segment.id))
        : null;
    if (panelById) return panelById;

    const panelByIndex = panels[index];
    if (
      panelByIndex &&
      (panelByIndex.id === undefined || panelByIndex.id === null)
    ) {
      return { ...panelByIndex, id: segment?.id ?? panelByIndex.id };
    }

    return emptyPanelForSegment(segment);
  });
};

export function serializeCanvasSavePayload(canvasData: any) {
  if (!canvasData || typeof canvasData !== 'object') return {};

  const {
    segments,
    obstacles,
    trees,
    colorRange,
    package: _packageData,
    ...canvas
  } = canvasData;

  if (segments) {
    canvas.segments = segments.map(
      ({
        acMonthly,
        poaMonthly,
        solarAccess,
        panelOrientation,
        tsrf,
        tof,
        ...segment
      }: any) => ({
        ...segment,
        panel_orientation: panelOrientation,
        ac_monthly: acMonthly,
        poa_monthly: poaMonthly,
        solar_access: solarAccess?.map(
          (val: number) => val?.toFixed?.(4) ?? val
        ),
        tsrf: tsrf?.map((val: number) => val?.toFixed?.(4) ?? val),
        tof: tof?.map((val: number) => val?.toFixed?.(4) ?? val)
      })
    );
  }
  if (obstacles) canvas.obstacles = obstacles;
  if (trees) canvas.trees = trees;
  if (colorRange) canvas.color_range = colorRange.join(',');

  return canvas;
}
